import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthProvider';
import { ConfirmProvider } from '@/components/Confirm';
import { ToastProvider } from '@/components/Toast';
import { PcOnlyGuard } from '@/layout/PcOnlyGuard';
import { AccessGate } from '@/features/security/AccessGate';
import { createQueryClient } from '@/lib/queryClient';
import { appRoutes } from './routes';

/** React Router v7 互換の挙動を先取り（移行時の差分を減らす） */
const ROUTER_FUTURE = {
  v7_relativeSplatPath: true,
  v7_fetcherPersist: true,
  v7_normalizeFormMethod: true,
  v7_partialHydration: true,
  v7_skipActionErrorRevalidation: true,
} as const;

export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createBrowserRouter(appRoutes, { future: ROUTER_FUTURE }));
  return (
    <PcOnlyGuard>
      {/* IP アドレス制限・端末証明書で利用できない場合は画面全体を案内に切り替える */}
      <AccessGate>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <ConfirmProvider>
              <AuthProvider>
                <RouterProvider router={router} future={{ v7_startTransition: true }} />
              </AuthProvider>
            </ConfirmProvider>
          </ToastProvider>
        </QueryClientProvider>
      </AccessGate>
    </PcOnlyGuard>
  );
}
